<template>
  <a-card :bordered="false" title="短链生成" :bodyStyle="{paddingTop:'0px'}"
          :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-form @submit="searchBtn" :form="form">
      <search-header :col="3">
        <search-list>
          <a-form-item label="长链地址" v-bind="formItemLayoutBtns">
            <a-input
              placeholder="请输入长链地址"
              autocomplete="off"
              v-decorator="['longUrl', { rules: [
                { required: true, message: '请输入长网址', trigger: 'blur' },
                { pattern: /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/, message: '请输入正确的网络链接', trigger: 'blur'},
                ] }]"
            ></a-input>
          </a-form-item>
          <a-form-item v-bind="formItemLayoutBtns" style="margin-left:5%;">
            <a-select default-value="0" style="width: 120px" @change="handleChange">
              <a-select-option value="0">
                永久有效
              </a-select-option>
              <a-select-option value="1">
                1年有效
              </a-select-option>
            </a-select>
            <a-button type="primary" style="margin-left:15px;" htmlType="submit">缩短网址</a-button>
          </a-form-item>
        </search-list>
      </search-header>
      <a-form-item v-bind="formItemLayoutBtns">
        <p v-if="isShortUrl">短链地址：{{ isShortUrl }}</p>
      </a-form-item>
    </a-form>
  </a-card>
</template>

<script>
import formMixins from '../../../../utils/mixins/formMixins'
import userHelper from '../../../../utils/helper/userHelper'

export default {
  name: 'GenerateLink',
  mixins: [formMixins],
  data() {
    return {
      queryParams: {},
      formItemLayoutBtns: {
        labelCol: {
          span: 0
        },
        wrapperCol: {
          span: 24
        }
      },
      longUrl: '',
      expirationType: 0,
      isShortUrl: ''
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [{ name: 'GenerateLink', title: '短链服务' }, {
      name: 'ShotLinkList',
      title: '短链列表'
    }])
  },
  mounted() {
  },
  methods: {
    searchBtn(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          let signMsg = new Date().getTime()
          let signValue = userHelper.md5('shortUrlSK' + signMsg + 'shortUrlSK')
          this.queryParams = {
            createType: 1,
            merchantId: this.$store.getters.userInfo.merchantId,
            platformId: this.getPlatformConfig().platformId,
            longUrl: values.longUrl,
            expirationType: this.expirationType,
            signMsg,
            signValue
          }
          this.getHttpServices().getShortService().post('getShortUrl', this.queryParams)
            .then(res => {
              this.isShortUrl = res
              this.$message.success('短链接生成成功')
            }).catch(reason => this.showNetWorkErrorMessage(reason))
        }
      })
    },
    handleChange(value) {
      this.expirationType = value
    }
  }

}
</script>
<style scoped>
</style>